import { render } from "./index.vue?vue&type=template&id=44edb244&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=44edb244&lang=css"
import "./index.vue?vue&type=style&index=1&id=44edb244&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44edb244"]])

export default __exports__